var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1814 4.14008L13.3926 2.92893L14.5711 4.10744L13.3599 5.31859C14.3863 6.60166 15 8.22917 15 10C15 14.1422 11.6422 17.5 7.5 17.5C3.35787 17.5 0 14.1422 0 10C0 5.85787 3.35787 2.5 7.5 2.5C9.27083 2.5 10.8983 3.11372 12.1814 4.14008ZM7.5 15.8333C10.7217 15.8333 13.3333 13.2217 13.3333 10C13.3333 6.77834 10.7217 4.16667 7.5 4.16667C4.27834 4.16667 1.66667 6.77834 1.66667 10C1.66667 13.2217 4.27834 15.8333 7.5 15.8333ZM6.66667 5.83333H8.33333V10.8333H6.66667V5.83333ZM4.16667 0H10.8333V1.66667H4.16667V0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.85e18acc6ccff6ebd9603a13e1b4d581.svg";
export { ForwardRef as ReactComponent };